import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import {
    Box,
    Button,
    IconButton,
    TextField,
    Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { CustomTabPanel } from ".";
import { useEffect, useState } from "react";
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import DashboardIcon from "@mui/icons-material/Dashboard";
import TableRowsIcon from '@mui/icons-material/TableRows';
import Groups2Icon from '@mui/icons-material/Groups2';
import './styles.scss';

const mappedFieldForMessage = [
    { "name": "Cuadrilla", "field": "group_assigned", type: "norepeat", exludeFromGeneral: true, hide: true },
    { "name": "Integrantes", "field": "name", type: "norepeat", exludeFromGeneral: true, hide: true },
    { "name": "Actividad planificada", "field": "tecnologiaPlanificada", type: "norepeat", hide: true },
    { "name": "Campo", "field": "field", type: "norepeat", exludeFromGeneral: true },

    { "name": "Pozos programados", "field": "pozosProgramados", type: "number" },
    { "name": "Pozos visitados", "field": "pozosVisitados", type: "number" },
    { "name": "Pozos aportando", "field": "pozosAportando", type: "number" },
    { "name": "Pozos operando", "field": "pozosOperando", type: "number" },
    { "name": "Pozos sin aporte", "field": "pozosSinAporte", type: "number" },
    { "name": "Para TDS", "field": "pozosSinProduccion", type: "number" },
    { "name": "Pozos Interrumpidos (IT)", "field": "pozosIT", type: "number" },
    { "name": "Pozos sin acceso", "field": "pozosSinAcceso", type: "number" },
    { "name": "Pozos recolocados", "field": "pozosRecolocado", type: "number" },
    { "name": "Pozos en observación", "field": "pozosEnObservacion", type: "number" },

    { "name": "Pozos reespaceados", "field": "pozosReespaceados", type: "number" },
    { "name": "Pozos restaurados", "field": "pozosRestaurados", type: "number" },

    { "name": "Producción asociada", "field": "produccionMonitoreado", type: "number" },
    { "name": "Producción restaurada", "field": "produccionRestaurada", type: "number" },
    { "name": "Producción diferida", "field": "produccionDiferida", type: "number" },

    { "name": "Cartas Leutert", "field": "estudiosLeutert", type: "number" },
    { "name": "Estudios Echometer", "field": "estudiosEchometer", type: "number" },
    { "name": "Numero Muestras", "field": "muestras", type: "number" },

    { "name": "Comenmtario", "field": "executedPlanningComment", type: "norepeat", fullSize: true },

    // { "name": "Cartas realizadas", "field": "cartasRealizadas", type: "number" },
    // { "name": "Fecha", "field": "fecha", type: "norepeat" },
]

const internalTabs = [
    { "name": "Resumen", "value": "summary", icon: <TextSnippetIcon /> },
    // { "name": "shortChart", "value": "shortChart", icon: <TableRowsIcon /> },
    { "name": "detaileChart", "value": "details", icon: <DashboardIcon /> },
]

interface GroupCards {
    grouped: string,
    members: string,
    field: string,
    techology: string,
    executed: number,
    planned: number,
    reespacedWells: number,
    pvExecuted: number,
    potExecuted: number,
    comment: string
}

const groupOfCardsDummy = [
    { "grouped": "C-1", "members": "Juan / Pedro", "field": "Bachaquero", "techology": "Echometer", "executed": 10, "planned": 12, "reespacedWells": 3, "pvExecuted": 2, "potExecuted": 450, "comment": "Good performance, needs improvement. Good performance, needs improvement.Good performance, needs improvement. Good performance, needs improvement. Good performance, needs improvement." },
    { "grouped": "C-2", "members": "Luis / Maria ", "field": "Bachaquero", "techology": "Leutert Digital", "executed": 50, "planned": 45, "reespacedWells": 3, "pvExecuted": 2, "potExecuted": 500, "comment": "Exceeded expectations, great job!" },
    { "grouped": "C-3", "members": "Pedro / Ana", "field": "Lagunillas", "techology": "Echometer", "executed": 70, "planned": 30, "reespacedWells": 5, "pvExecuted": 0, "potExecuted": 250, "comment": "Outstanding performance, keep it up." },
    { "grouped": "C-4", "members": "Carlos / Luisabel", "field": "Lagunillas", "techology": "Leutert Digital", "executed": 20, "planned": 40, "reespacedWells": 10, "pvExecuted": 2, "potExecuted": 150, "comment": "Needs improvement in execution." }
]

const ChartComponent = ({ value, messageSummary, start, end }: { value: any, messageSummary: any, start: any, end: any }) => {


    const [groupOfCards, setGroupOfCards] = useState<GroupCards[]>(groupOfCardsDummy)


    useEffect(() => {

        const groupOfCards: GroupCards[] = []

        if (!messageSummary) return

        for (const cuadrilla of Object.keys(messageSummary) || []) {
            const dataCuadrilla = messageSummary[cuadrilla]

            groupOfCards.push({
                grouped: dataCuadrilla['group_assigned']?.replace('cuadrilla', 'C'),
                members: dataCuadrilla['name'],
                field: dataCuadrilla['field'],
                techology: dataCuadrilla['tecnologia'],
                executed: dataCuadrilla['pozosVisitados'],
                planned: dataCuadrilla['pozosProgramados'],
                reespacedWells: dataCuadrilla['pozosReespaceados'],
                pvExecuted: dataCuadrilla['pozosPruebaValvula'],
                potExecuted: dataCuadrilla['produccionMonitoreado'],
                comment: dataCuadrilla['executedPlanningComment']
            })

        }

        setGroupOfCards(groupOfCards)

    }, [messageSummary])



    return (
        <Box sx={{ width: "100%" }}>
            <Grid className="daily-report-card-container">
                {groupOfCards.map((card, index) => (
                    <Box key={index}>
                        <Box className="daily-report-card">
                            <Box className="title-row">{card.grouped} - {card.members}</Box>
                            <Box className="data-row">{card.field} - {card.techology}</Box>
                            <Box className="progress-row">
                                <Box className="value">
                                    {Math.round((card.executed / card.planned) * 100)}% - ({card.executed}/{card.planned})
                                </Box>
                                <Box
                                    className="background-progress"
                                    sx={{
                                        width: `${Math.round((card.executed / card.planned) * 100)}%`,
                                    }}

                                />
                            </Box>
                            <Box>
                                <Box className="detaialed-row">
                                    <Grid className="data-row">Reespaceados</Grid>
                                    <Grid className="data-row">PV</Grid>
                                    <Grid className="data-row">Pot</Grid>
                                </Box>
                                <Box className="detaialed-row">
                                    <Grid className="data-row">{card.reespacedWells}</Grid>
                                    <Grid className="data-row">{card.pvExecuted}</Grid>
                                    <Grid className="data-row">{card.potExecuted} BNPD</Grid>
                                </Box>
                            </Box>
                            <Box className="title-row">Comentario</Box>
                            <Box className="comment-row">{card.comment}</Box>
                        </Box>
                    </Box>
                ))}
            </Grid>
        </Box>
    )
}

export const SummaryComponent = ({ value, messageSummary, start, end, onClickUpdateTask, activesSquadData, setActivesSquadData }: { value: any, messageSummary: any, start: any, end: any, onClickUpdateTask: any, activesSquadData: any, setActivesSquadData: any }) => {


    const [activesSquad, setActivesSquad] = useState<string[]>(["all"])

    const [activeSummaryView, setactiveSummaryView] = useState(internalTabs[0].value)

    const [dataToShowFromAllFields, setDataToShowFromAllFields] = useState<any>({})

    const [wsMessage, setWsMessage] = useState<any>({ groupMessage: "", individualMessages: [] })


    useEffect(() => {
        let enabledSquad = Object.keys(messageSummary || {})

        enabledSquad = enabledSquad.sort((a, b) => {
            const fieldA = messageSummary[a].field || "unknown_field";
            const fieldB = messageSummary[b].field || "unknown_field";

            if (fieldA < fieldB) return -1;
            if (fieldA > fieldB) return 1;
            return 0;
        })

        if (!activesSquad.includes("all")) {
            enabledSquad = enabledSquad.filter((item) => activesSquad.includes(item))
        }

        const newActivesSquadData: any = {}

        const individualMessages: string[] = []     

        let lastFieldFroSquad = ''


        enabledSquad.forEach((item: any) => {

            const fieldForSquad = messageSummary[item].field || "unknown_field";

            if (!newActivesSquadData[fieldForSquad]) {
                const numberOfSquads = Object.keys(messageSummary || {}).filter((item) => messageSummary[item].field === fieldForSquad && enabledSquad.includes( messageSummary[item].name)).length;
                newActivesSquadData[fieldForSquad] = {
                    squatsNumber : numberOfSquads,
                };
            }

            let individualTextMessage = ``

            if (lastFieldFroSquad !== fieldForSquad) {
                individualTextMessage += `*Campo*: ${fieldForSquad}\n\n`
                lastFieldFroSquad = fieldForSquad
            }

            const dataForSquad = messageSummary[item]

            mappedFieldForMessage.forEach((field) => {
                if (field.type === "number" && !isNaN(dataForSquad[field.field])) {
                    newActivesSquadData[fieldForSquad][field.field] = parseFloat(newActivesSquadData[fieldForSquad][field.field] || 0) + parseFloat(dataForSquad[field.field]);
                } else if (field.type === "norepeat") {
                    const preValue = newActivesSquadData[fieldForSquad][field.field];


                    if (preValue === undefined && dataForSquad[field.field] !== undefined) {
                        newActivesSquadData[fieldForSquad][field.field] = `${dataForSquad[field.field]}`;
                    } else if (newActivesSquadData[fieldForSquad][field.field] && !preValue?.includes(dataForSquad[field.field])) {
                        newActivesSquadData[fieldForSquad][field.field] = `${newActivesSquadData[fieldForSquad][field.field]} / ${dataForSquad[field.field] || ""}`;
                    }
                } else {
                    const preValue = newActivesSquadData[fieldForSquad][field.field];

                    if (preValue === undefined) {
                        newActivesSquadData[fieldForSquad][field.field] = dataForSquad[field.field] || " ";
                    } else {
                        newActivesSquadData[fieldForSquad][field.field] = `${newActivesSquadData[fieldForSquad][field.field]} ${dataForSquad[field.field] || ""}`;
                    }
                }

                if (dataForSquad[field.field] !== undefined && dataForSquad[field.field] !== null) {
                    individualTextMessage += `*${field.name}*: ${dataForSquad[field.field]}\n`
                }
            })

            individualMessages.push(individualTextMessage)
        })

        const summaryToShow: any = {}

        Object.keys(newActivesSquadData).forEach((field) => {

            mappedFieldForMessage.forEach((mappedField) => {

                if (!Object.keys(summaryToShow).includes(mappedField.field)) {

                    summaryToShow[mappedField.field] = newActivesSquadData[field][mappedField.field]

                } else {
                    if (typeof summaryToShow[mappedField.field] === "number") {
                        summaryToShow[mappedField.field] += newActivesSquadData[field][mappedField.field] || 0;

                    } else if (typeof summaryToShow[mappedField.field] === "string") {
                        if (newActivesSquadData[field][mappedField.field] !== undefined && newActivesSquadData[field][mappedField.field] !== null) {
                            summaryToShow[mappedField.field] += ` / ${newActivesSquadData[field][mappedField.field]}`;
                        }
                    }
                }

            })
        })

        setDataToShowFromAllFields(summaryToShow)

        const groupMessage = getSummary(newActivesSquadData)

        setWsMessage({ groupMessage, individualMessages })


        setActivesSquadData(newActivesSquadData)

    }, [activesSquad, messageSummary])


    const onClickSquad = (field: string) => {

        if (field === "all") {
            setActivesSquad(["all"])
            return
        } if (activesSquad.includes(field)) {
            const newActivesSquad = activesSquad.filter((item) => item !== field);

            if (newActivesSquad.length === 0) {
                newActivesSquad.push("all")
            }

            setActivesSquad([...newActivesSquad]);
            return
        } else {
            const newActivesSquad = activesSquad.filter((item) => item !== "all");

            setActivesSquad([...newActivesSquad, field]);
            return
        }
    }

    const getSummary = (enableSquadData:any) => {

         const fechaText = start === end ? start : `${start} - ${end}`

        let textMessage = `Buenas tardes, A continuación se anexa reporte consolidado General por Campo para el día: ${fechaText} \n\n`
        
        for (const field of Object.keys(enableSquadData || {})) {
            textMessage += `*Campo ${field}*\n\n`
            const data = enableSquadData[field];
            textMessage += `*Total Cuadrillas*:  ${data.squatsNumber}\n`
            textMessage += `*Actividad planificada*:  ${data.tecnologiaPlanificada}\n`
            textMessage += `*Pozos programados*:  ${data.pozosProgramados}\n`
            textMessage += `*Pozos visitados*:  ${data.pozosVisitados}\n`
            textMessage += `*Pozos aportando*:  ${data.pozosAportando + data.pozosOperando + data.pozosRecolocado + data.pozosRestaurados}\n`
            textMessage += `*Pozos sin aporte*:  ${data.pozosSinAporte + data.pozosEnObservacion + data.pozosSinProduccion}\n`
            textMessage += `*Pozos Interrumpidos(IT)*:  ${data.pozosIT}\n`
            textMessage += `*Pozos sin acceso*:  ${data.pozosSinAcceso}\n`

            textMessage += `*Producción asociada*:  ${data.produccionMonitoreado}\n`
            textMessage += `*Producción diferida*:  ${data.produccionDiferida}\n`

            textMessage += `*Cartas leutert*:  ${data.estudiosLeutert}\n`
            textMessage += `*Estudios Echometer*:  ${data.estudiosEchometer}\n`
            textMessage += `*Numero de muestras*:  ${data.muestras}\n`

            textMessage += `\n`            
        }

        return textMessage
    }


    const onClickCopy = ({ type }: { type: "all" | "Summary" }) => {

        if (type === "all") {
            const textToCopy = wsMessage.groupMessage
            navigator.clipboard.writeText(textToCopy).then(() => {
                alert('Mensaje copiado al portapapeles');
            }).catch(err => {
                console.error('Error al copiar el mensaje: ', err);
            });

        } else {

            const headerText = `Buenas tardes, a continuación, se describe el resumen de actividades ejecutadas por las cuadrillas de campo NABEP. \n\n`

            const fecha = `*Fecha*: ${start === end ? start : `${start} - ${end}`}\n\n`

            const textToCopy = `${headerText} ${fecha} ${wsMessage.individualMessages.join("\n\n")}`
            navigator.clipboard.writeText(textToCopy).then(() => {
                alert('Mensaje copiado al portapapeles');
            }).catch(err => {
                console.error('Error al copiar el mensaje: ', err);
            });
        }



    }

    const onClickSendWhatsApp = () => {
        const textToCopy = wsMessage.groupMessage + "\n\n" + wsMessage.individualMessages.join("\n\n")

        const phoneNumber = prompt('Ingrese el número de teléfono con el código de país (ej. 584246870497):');
        if (!phoneNumber) {
            alert('Número de teléfono no proporcionado.');
            return;
        }

        // const phoneNumber = '584246870497'; // Reemplaza con el número de teléfono deseado
        if (wsMessage !== "") {
            const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(textToCopy)}`;
            window.open(url, '_blank');
        }
    }

    const onClickOpenActivity = () => {
        onClickUpdateTask(activesSquadData)
    }

    const onClickChangeSummaryView = (tabId: string) => {
        setactiveSummaryView(tabId)
    }

    return (
        <CustomTabPanel value={value} index={0}>
            {/* Buttons */}
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 3, gap: 2 }}>
                    {
                        internalTabs.map((item, index) => {
                            return (
                                <IconButton
                                    onClick={() => onClickChangeSummaryView(item.value)}
                                    key={index}
                                    className="active_button"
                                    sx={{
                                        backgroundColor: activeSummaryView === item.value ? "#1976d2" : "#f0f0f0",
                                        color: activeSummaryView === item.value ? "#fff" : "#000",
                                        "&:hover": {
                                            backgroundColor: activeSummaryView === item.value ? "#42a5f5" : "#f0f0f0",
                                        },
                                    }}
                                >
                                    {item.icon}
                                </IconButton>
                            )
                        })
                    }
                </Box>
                {/* Buttons Right */}
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, }}>
                    <IconButton
                        onClick={onClickSendWhatsApp}
                        sx={{
                            backgroundColor: "#25D366",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "#128C7E",
                            },
                        }}
                    >
                        <WhatsAppIcon />
                    </IconButton>
                    <Tooltip title="Resumen" placement="top">
                        <IconButton
                            onClick={() => onClickCopy({ type: "all" })}
                            sx={{
                                backgroundColor: "#03365e",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#129ED3",
                                },
                                ml: 2,
                            }}
                        >
                            <FileCopyOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Detalle Por Cuadrilla" placement="top">
                        <IconButton
                            onClick={() => onClickCopy({ type: "Summary" })}
                            sx={{
                                backgroundColor: "#98B6DD",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#129ED3",
                                },
                                ml: 2,
                            }}
                        >
                            <Groups2Icon />
                        </IconButton>
                    </Tooltip>
                    {/* <IconButton
                        onClick={onClickOpenActivity}
                        disabled={activesSquad?.length > 1 || activesSquad.includes("all")}
                        sx={{
                            backgroundColor: "#03365e",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "#129ED3",
                            },
                            ml: 2,
                        }}
                    >
                        <OpenInNewIcon />
                    </IconButton> */}
                </Box>
            </Box>

            {/* squads */}
            <Grid size={12}>
                <Box className="dashboard_container_filter_container">
                    <Grid size={2}>
                        <Button variant="outlined" fullWidth onClick={() => onClickSquad("all")} className={activesSquad.includes("all") ? "activeButton" : ""} > Todos </Button>
                    </Grid>
                    {Object.keys(messageSummary || {}).map(
                        (key, index) => {
                            return (
                                <Grid size={5} key={index}>
                                    <Button
                                        variant="outlined"
                                        fullWidth
                                        onClick={() => onClickSquad(key)}
                                        className={activesSquad.includes(key) ? "activeButton" : ""}
                                        sx={{
                                            maxHeight: '170px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            padding: '4px 8px',
                                            fontSize: '0.875rem',
                                        }}
                                    >
                                        {key} - {messageSummary[key].group_assigned?.replace("cuadrilla", "c")}
                                        - {messageSummary[key].field} - {messageSummary[key].tecnologia}
                                    </Button>
                                </Grid>
                            );
                        }
                    )}
                </Box>
            </Grid>

            {activeSummaryView === "summary" && (
                <Box sx={{ width: "100%" }}>
                    <Grid container spacing={2} sx={{ mt: 5 }}>
                        {mappedFieldForMessage?.map((item, index) => {

                            if (item.hide) return null;

                            return (
                                <Grid size={item?.fullSize ? 12 : 3} key={index}>
                                    <TextField
                                        id="outlined-basic"
                                        label={item.name}
                                        variant="outlined"
                                        fullWidth
                                        value={dataToShowFromAllFields[item.field] !== undefined && dataToShowFromAllFields[item.field] !== null ? dataToShowFromAllFields[item.field] : " "}
                                    />
                                </Grid>
                            )
                        })}
                    </Grid>
                </Box>
            )}

            {activeSummaryView === "details" && (
                <ChartComponent value={value} messageSummary={messageSummary} start={start} end={end} />
            )}


        </CustomTabPanel>
    )
}